export const SET_USER_OFFERS = 'SET_USER_OFFERS';

export const SET_PURCHASES = 'SET_PURCHASES';
